<template>
  <div>
    <div container>
      <div grid="row wrap" column="12">
        <div v-html="billing_info_header_html"></div>
      </div>
      <div grid="row wrap" v-if="this.value.userMessage.length !==0 ">
        <ul>
          <li v-for="item in this.value.userMessage" >
            <p class="lips validation">{{ item}} </p>
          </li>
        </ul>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="3">
          <app-input
            ref="billingContactFirstName"
            :errorMessage="billingContactFirstNameError"
            :invalid="$v.internalValue.billingContactFirstName.$invalid"
            :required="false"
            label="Billing Contact First Name:"
            v-model="$v.internalValue.billingContactFirstName.$model"
            valueKey="billingContactFirstName"
            @input="emitBillingInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="billingContactLastNameError"
            :invalid="$v.internalValue.billingContactLastName.$invalid"
            :required="false"
            label="Billing Contact Last Name:"
            v-model="$v.internalValue.billingContactLastName.$model"
            valueKey="billingContactLastName"
            @input="emitBillingInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="billingContactPhoneError"
            :invalid="$v.internalValue.billingContactPhone.$invalid"
            :required="false"
            label="Billing Contact Phone:"
            v-model="$v.internalValue.billingContactPhone.$model"
            valueKey="billingContactPhone"
            maxlength="12"
            :pattern="[0-9]"
            @input="[formatBillingContactPhone(),emitBillingInformation()]"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="billingContactEmailError"
            :invalid="$v.internalValue.billingContactEmail.$invalid"
            :required="false"
            label="Billing Contact Email:"
            v-model="$v.internalValue.billingContactEmail.$model"
            valueKey="billingContactEmail"
            @input="emitBillingInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="3">
          <app-select
            :errorMessage="billingInvoiceNeedToSortError"
            :invalid="$v.internalValue.billingInvoiceNeedToSort.$invalid"
            :options="this.yesNoOptions"
            :required='false'
            label='Need To Sort Invoices/Rosters?'
            v-model="$v.internalValue.billingInvoiceNeedToSort.$model"
            valueKey='billingInvoiceNeedToSort'
            @input="emitBillingInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="6">
          <app-checkbox-simple
            :value="this.internalValue.billingAddSameAsBusinessAdd"
            @click="toggleBusinessAddress($event)"
            label="Billing Address Matches Business Address?"
            valueKey="billingAddSameAsBusinessAdd"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="billingAddressLine1Error"
            :invalid="$v.internalValue.billingAddressLine1.$invalid"
            :required="false"
            label="Billing Address Line 1:"
            v-model="$v.internalValue.billingAddressLine1.$model"
            valueKey="billingAddressLine1"
            @input="emitBillingInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="billingAddressLine2Error"
            :invalid="$v.internalValue.billingAddressLine2.$invalid"
            :required="false"
            label="Billing Address Line 2:"
            v-model="$v.internalValue.billingAddressLine2.$model"
            valueKey="billingAddressLine2"
            @input="emitBillingInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="billingZipCodeError"
            :invalid="$v.internalValue.billingZipCode.$invalid"
            :required="false"
            label="Billing Zip Code:"
            pattern="[0-9]"
            type="number"
            v-model="$v.internalValue.billingZipCode.$model"
            valueKey="billingZipCode"
            @input="zipCodeUpdated"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="billingCityError"
            :invalid="$v.internalValue.billingCity.$invalid"
            :required="false"
            label="Billing City:"
            v-model="$v.internalValue.billingCity.$model"
            valueKey="billingCity"
            @input="emitBillingInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="3">
          <app-select
            :errorMessage="billingStateError"
            :invalid="$v.internalValue.billingState.$invalid"
            :options="this.newClientStateOptions"
            :required='false'
            label='Billing State'
            v-model="$v.internalValue.billingState.$model"
            valueKey='billingState'
            @input="emitBillingInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <button
          @click="saveBillingInformation()" class="btn --sm _mtxs"
          column="12"
          :disabled="$v.$invalid || this.hasTitleSectionError"
        >
          Continue
        </button>
      </div>
      <div>
        <hr class="_mbxs _mts">
      </div>
    </div>
  </div>
</template>

<script>
  import AppInput from '@atoms/Input'
  import AppSelect from '@atoms/Select'
  import AppCheckboxSimple from '@atoms/CheckboxSimple'
  import clientOnboardSelectOptions from '@mixins/clientOnboardSelectOptions'
  import ZipCodeHelper from '@mixins/ZipCodeHelper'
  import formReady from '@mixins/formReady'
  import clientOnboardVerbiage from '@mixins/clientOnboardVerbiage'

  import { email, maxLength, numeric, requiredIf } from 'vuelidate/lib/validators'
  import { fiveDigitsLong, twelveDigitsLong, formatPhone } from '@/utils'
  import { eventBus } from '@/main'

  export default {
    mixins: [
      formReady,
      clientOnboardSelectOptions,
      ZipCodeHelper,
      clientOnboardVerbiage
    ],
    components: {
      AppInput,
      AppSelect,
      AppCheckboxSimple
    },
    props: {
      value: {
        type: Object
      }
    },
    data() {
      return {
        isLastSigner: this.value.billingInfoValues.isLastSigner,
        hasTitleSectionError: this.value.billingInfoValues.hasTitleSectionError,
        internalValue: {
          billingContactFirstName: this.value.billingInfoValues.billingContactFirstName || '',
          billingContactLastName: this.value.billingInfoValues.billingContactLastName || '',
          billingContactPhone: this.value.billingInfoValues.billingContactPhone || '',
          billingContactEmail: this.value.billingInfoValues.billingContactEmail || '',
          billingInvoiceNeedToSort: this.value.billingInfoValues.billingInvoiceNeedToSort || '',
          billingAddressLine1: this.value.billingInfoValues.billingAddressLine1 || '',
          billingAddressLine2: this.value.billingInfoValues.billingAddressLine2 || '',
          billingZipCode: this.value.billingInfoValues.billingZipCode || '',
          billingCity: this.value.billingInfoValues.billingCity || '',
          billingState: this.value.billingInfoValues.billingState || '',
          billingAddSameAsBusinessAdd: this.value.billingInfoValues.billingAddSameAsBusinessAdd
        }
      }
    },
    validations: {
      internalValue: {
        billingContactFirstName: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(27)
        },
        billingContactLastName: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(27)
        },
        billingContactPhone: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          twelveDigitsLong
        },
        billingContactEmail: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          email,
          maxLength: maxLength(77)
        },
        billingInvoiceNeedToSort: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        billingAddressLine1: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(40)
        },
        billingAddressLine2: {
          maxLength: maxLength(40)
        },
        billingZipCode: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          numeric,
          fiveDigitsLong
        },
        billingCity: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(19)
        },
        billingState: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        }
      }
    },
    computed: {
      billingContactFirstNameError() {
        if (!this.$v.internalValue.billingContactFirstName.required) {
          return 'required'
        } else if (!this.$v.internalValue.billingContactFirstName.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      billingContactLastNameError() {
        if (!this.$v.internalValue.billingContactLastName.required) {
          return 'required'
        } else if (!this.$v.internalValue.billingContactLastName.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      billingContactPhoneError() {
        if (!this.$v.internalValue.billingContactPhone.required) {
          return 'required'
        } else if (!this.$v.internalValue.billingContactPhone.twelveDigitsLong) {
          return '10 digits long'
        }
        return null
      },
      billingContactEmailError() {
        if (!this.$v.internalValue.billingContactEmail.required) {
          return 'required'
        } else if (!this.$v.internalValue.billingContactEmail.email) {
          return 'not a valid email address'
        } else if (!this.$v.internalValue.billingContactEmail.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      billingInvoiceNeedToSortError() {
        if (!this.$v.internalValue.billingInvoiceNeedToSort.required) {
          return 'required'
        }
        return null
      },
      billingAddressLine1Error() {
        if (!this.$v.internalValue.billingAddressLine1.required) {
          return 'required'
        } else if (!this.$v.internalValue.billingAddressLine1.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      billingAddressLine2Error() {
        if (!this.$v.internalValue.billingAddressLine2.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      billingZipCodeError() {
        if (!this.$v.internalValue.billingZipCode.required) {
          return 'required'
        }
        let hasValue = this.$v.internalValue.billingZipCode.$model
        if (hasValue && (this.$v.internalValue.billingZipCode.$dirty || this.$v.internalValue.billingZipCode.$model.length !== 0)) {
          if (!this.$v.internalValue.billingZipCode.numeric) {
            return 'must be numeric'
          } else if (!this.$v.internalValue.billingZipCode.fiveDigitsLong) {
            return '5 digits long'
          }
        }
        return null
      },
      billingCityError() {
        if (!this.$v.internalValue.billingCity.required) {
          return 'required'
        } else if (!this.$v.internalValue.billingCity.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      billingStateError() {
        if (!this.$v.internalValue.billingState.required) {
          return 'required'
        }
        return null
      }
    },
    methods: {
      toggleBusinessAddress(event) {
        if (event !== null) { // use the check box click value wen clicked otherwise procced with the current value
          this.internalValue.billingAddSameAsBusinessAdd = event.target.checked
        }
        if (this.internalValue.billingAddSameAsBusinessAdd) {
          if (this.checkIfBusinessAddressValuesEmpty()) { // if business address values are empty,clear the billing address values
            if (event !== null) {
              alert('Business Address field was not previously entered.')
              event.preventDefault()
            }
            this.internalValue.billingAddSameAsBusinessAdd = false
            // this.clearBillingInfo();
          } else { // set the business address values
            this.internalValue.billingAddressLine1 = this.value.groupInfoValues.businessAddressLine1
            this.internalValue.billingAddressLine2 = this.value.groupInfoValues.businessAddressLine2
            this.internalValue.billingZipCode = this.value.groupInfoValues.businessZipCode
            this.internalValue.billingCity = this.value.groupInfoValues.businessCity
            this.internalValue.billingState = this.value.groupInfoValues.businessState !== null ? this.value.groupInfoValues.businessState.value : ''
          }
        } else if (event !== null) { // clear when check box set to false but not on page mount
          // this.clearBillingInfo();
        }
        this.emitBillingInformation()
      },
      checkIfBusinessAddressValuesEmpty() {
        return (this.value.groupInfoValues.businessAddressLine1 === undefined || this.value.groupInfoValues.businessAddressLine1 === '') &&
          (this.value.groupInfoValues.businessAddressLine2 === undefined || this.value.groupInfoValues.businessAddressLine2 === '') &&
          (this.value.groupInfoValues.businessZipCode === undefined || this.value.groupInfoValues.businessZipCode === '') &&
          (this.value.groupInfoValues.businessCity === undefined || this.value.groupInfoValues.businessCity === '')
      },
      clearBillingInfo() {
        this.internalValue.billingAddressLine1 = ''
        this.internalValue.billingAddressLine2 = ''
        this.internalValue.billingZipCode = ''
        this.internalValue.billingCity = ''
        this.internalValue.billingState = ''
      },
      formatBillingContactPhone() {
        this.internalValue.billingContactPhone = formatPhone(this.internalValue.billingContactPhone)
      },
      zipCodeUpdated() {
        this.internalValue.billingCity = ''
        this.internalValue.billingState = ''
        if (this.$v.internalValue.billingZipCode.$invalid || this.internalValue.billingZipCode === '') {
          this.emitBillingInformation()
          return
        }
        this.suggestLocationFromPublicUtilZipCode(this.internalValue.billingZipCode)
          .then((suggestion) => {
            if (!suggestion) {
              this.emitBillingInformation()
              return
            }
            if (suggestion.state) {
              this.internalValue.billingCity = suggestion.city
              this.internalValue.billingState = suggestion.state
              this.emitBillingInformation()
            }
          })
      },
      isFormValid() {
        this.$v.$touch()
        return !this.$v.$error
      },
      saveBillingInformation() {
        if (this.isFormValid()) {
          this.$emit('continue', this.internalValue)
        }
      },
      emitBillingInformation() {
        this.$emit('billingInfoUpdated', this.internalValue)
      }
    },
    mounted() {
      this.$refs.billingContactFirstName.$el.children[1].focus()
      setTimeout(() => document.getElementById('BillingTitle').scrollIntoView(), 100)
      // this.toggleBusinessAddress(null);
    },
    created() {
      eventBus.$on('groupTitleSectionHasError', (data) => {
        this.hasTitleSectionError = data
      })
    },
    watch: {
      internalValue: {
        deep: true,
        handler() {
          this.$emit('valueChanged', true)
        }
      }
    }
  }
</script>
